// extracted by mini-css-extract-plugin
export default {"bettingGrid":"eh_ei","bettingGrid_hidden":"eh_ej","bettingGrid_planted":"eh_ek","bettingGrid_collapsed":"eh_el","bettingGrid__betOnSome":"eh_em"};